import type { Rv2Lang } from "./types";

const VALID_LANGS: Rv2Lang[] = ["fr", "en", "ar"];

export function normalizeLang(raw: string | null | undefined): Rv2Lang {
  if (raw && VALID_LANGS.includes(raw as Rv2Lang)) return raw as Rv2Lang;
  return "fr";
}

/** Append or replace ?lang= on an href, preserving hash and other query params. */
export function withLang(href: string, lang: string): string {
  const l = normalizeLang(lang);
  const hashIdx = href.indexOf("#");
  const hash = hashIdx >= 0 ? href.slice(hashIdx) : "";
  const beforeHash = hashIdx >= 0 ? href.slice(0, hashIdx) : href;
  const qIdx = beforeHash.indexOf("?");
  const path = qIdx >= 0 ? beforeHash.slice(0, qIdx) : beforeHash;
  const query = qIdx >= 0 ? beforeHash.slice(qIdx + 1) : "";
  const params = new URLSearchParams(query);
  if (l === "fr") {
    params.delete("lang");
  } else {
    params.set("lang", l);
  }
  const qs = params.toString();
  return `${path}${qs ? `?${qs}` : ""}${hash}`;
}

export function readStoredLang(): Rv2Lang | null {
  if (typeof window === "undefined") return null;
  try {
    const stored = window.localStorage.getItem("lang");
    return stored && VALID_LANGS.includes(stored as Rv2Lang) ? (stored as Rv2Lang) : null;
  } catch {
    return null;
  }
}

export function syncLangInUrl(lang: Rv2Lang): void {
  if (typeof window === "undefined") return;
  const next = withLang(`${window.location.pathname}${window.location.search}${window.location.hash}`, lang);
  const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  if (next !== current) {
    window.history.replaceState(null, "", next);
  }
}
